import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-environnement',
  templateUrl: './environnement.component.html',
  styleUrls: ['./environnement.component.scss']
})
export class EnvironnementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
